import { jwtDecode } from 'jwt-decode';
import { getAuth } from '../AuthProvider';
import { rolesMapping } from './RolesUtils';

export function hasAnyRole(roles, token=localStorage.getItem('access_token')) {

    if (token) {
        const decodedToken = jwtDecode(token);

        const isAdmin = decodedToken.realm_access?.roles?.includes(rolesMapping.admin);

        if (isAdmin) {
            return true;
        }

        for (var role of roles) {
            const hasPermission = decodedToken.realm_access?.roles?.includes(role);
            if (hasPermission)
                return true;
        }
    }

    return false;
}

export function getUserLogged(token=localStorage.getItem('access_token')) {

    if (token) {
        const decodedToken = jwtDecode(token);

        return decodedToken?.preferred_username;
    }

    return "";
}

export function getUserId(token=localStorage.getItem('access_token')) {

    if (token) {
        const decodedToken = jwtDecode(token);

        return decodedToken?.sub;
    }

    return "";
}


export function logout() {
    getAuth()?.handleLogout({path: '?reason=expired'});
    getAuth()?.showSessionExpiredModal();
}

export function isInvalidToken() {

    const token = localStorage.getItem('access_token');

    if (!token) {
        return true;
    }
    
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Em segundos

    return decodedToken.exp < currentTime;
}
